/**
 * A vendor's tagline, as the dashboard edits it.
 * ─────────────────────────────────────────────────────────────────────────────
 * One plain, factual line about what a vendor sells, shown under the vendor's
 * name on lusuku.ug and in the apps. The vendor writes it in Settings >
 * Business profile; Lusuku staff can write it from the vendor's admin page.
 * Restaurants, shops and wholesalers, pharmacies and brands all use it.
 *
 * The server owns the rule (models/shared/vendorTaglineField.js and
 * services/vendors/vendorTagline.js): it strips markup, collapses spaces and
 * refuses more than 100 characters with 400 TAGLINE_TOO_LONG. The number
 * below only sizes the input and its counter so nobody can type past the
 * limit the server enforces.
 *
 * Nothing is ever filled in for a vendor. A blank tagline shows nothing.
 */

export const VENDOR_TAGLINE_MAX_LENGTH = 100;

export const VENDOR_TAGLINE_LABEL = "Tagline";

export const VENDOR_TAGLINE_PLACEHOLDER = "What this business sells, in one line";

export const VENDOR_TAGLINE_HINT =
  "One plain, factual line about what this business sells. It shows under the business name on lusuku.ug and in the Lusuku app. Leave it blank to show nothing.";

/* "37/100" under the field. */
export const vendorTaglineCount = (value) =>
  `${String(value || "").length}/${VENDOR_TAGLINE_MAX_LENGTH}`;
